module.exports = __webpack_public_path__ + "static/media/Discord_mini_001-ezgif.com-optimize.28f60feb.gif";